import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultBannerData, getBannerById, updateBanner, createBanner } from '@/api/banner';
import { getProducts } from '@/api/products';
import { getCategories } from '@/api/categories';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
import { getQuery } from '@/utils';
import { getBranches } from '@/api/locations/branches';
import { getAgents } from '@/api/agents';
import { getDealerCities, getDealerIds } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.validity = [];
    this.productList = [];
    this.categoryList = [];
    this.pageList = [{
      label: 'Product',
      page: 'Product'
    }, {
      label: 'Category',
      page: 'Category'
    }, {
      label: 'External Link',
      page: 'External Link'
    }, {
      label: 'Others',
      page: 'Others'
    }];
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultBannerData);
    this.loading = false;
    this.desktopImage = [];
    this.mobileImage = [];
    this.isReadOnly = false;
    this.branchList = [];
    this.cityList = [];
    this.stateList = [];
    this.agentsList = [];
    this.selectedAgents = [];
    this.selectedBranches = [];
    this.selectedCities = [];
    this.selectedStates = [];
    this.selectedDealers = [];
    this.rules = {
      mobileImage: [{
        required: true,
        message: 'Please upload image',
        trigger: 'blur'
      }],
      name: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      params: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      categoryId: [{
        required: true,
        message: 'Please select category',
        trigger: 'blur'
      }],
      productId: [{
        required: true,
        message: 'Please select product',
        trigger: 'blur'
      }],
      link: [{
        required: true,
        trigger: 'blur'
      }, {
        pattern: /[-a-zA-Z0-9@%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
        message: 'Invalid URL format',
        trigger: ['blur', 'change']
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    // get categories
    this.getCategories();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultBannerData);
    }
    this.getBranches();
    this.getAgents();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getBannerById(id);
      this.formData = data;
      if (this.formData.validFrom && this.formData.validTill) {
        this.validity = [new Date(this.formData.validFrom), new Date(this.formData.validTill)];
      }
      if (data && data.desktopImage) {
        this.desktopImage.push({
          name: data.name,
          url: data.desktopImage
        });
      }
      if (data && data.mobileImage) {
        this.mobileImage.push({
          name: data.name,
          url: data.mobileImage
        });
      }
      if (this.formData.page === 'Product') {
        this.getProductById(this.formData.productId);
      }
      if (this.formData.page === 'Category') {
        this.getCategoryById(this.formData.categoryId);
      }
      // Just for test
      const title = 'Edit Banner';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (error) {
      this.$message.error(error.toString());
    }
  }
  async getBranches() {
    try {
      const branches = await getBranches(getQuery({
        enabled: true
      }));
      this.branchList = branches.map(branch => {
        return {
          key: branch.id,
          label: branch.code
        };
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getAgents() {
    try {
      const agents = await getAgents(getQuery({
        enabled: true
      }));
      this.agentsList = agents.map(agent => {
        return {
          id: agent.id,
          name: agent.name
        };
      });
      const dealers = await getDealerIds({
        branchIds: this.selectedBranches,
        agentIds: this.selectedAgents,
        cityIds: this.selectedCities,
        stateIds: this.selectedStates
      });
      this.selectedDealers = dealers;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async handleBranchChange(value) {
    try {
      this.cityList = [];
      this.stateList = [];
      const branchId = this.selectedBranches;
      const address = await getDealerCities({
        branchId
      });
      this.cityList = address.cityList;
      this.stateList = address.stateList;
      // map cityList
      this.cityList = this.cityList.map(city => {
        return {
          key: city.id,
          label: city.name
        };
      });
      this.stateList = this.stateList.map(state => {
        return {
          key: state.id,
          label: state.name
        };
      });
      const dealers = await getDealerIds({
        branchIds: this.selectedBranches,
        agentIds: this.selectedAgents,
        cityIds: this.selectedCities,
        stateIds: this.selectedStates
      });
      this.selectedDealers = dealers;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async handleAgentChange(value) {
    try {
      this.cityList = [];
      this.stateList = [];
      const agentId = this.selectedAgents;
      const branchId = this.selectedBranches;
      const address = await getDealerCities({
        branchId,
        agentId
      });
      this.cityList = address.cityList;
      this.stateList = address.stateList;
      this.cityList = this.cityList.map(city => {
        return {
          key: city.id,
          label: city.name
        };
      });
      this.stateList = this.stateList.map(state => {
        return {
          key: state.id,
          label: state.name
        };
      });
      const dealers = await getDealerIds({
        branchIds: this.selectedBranches,
        agentIds: this.selectedAgents,
        cityIds: this.selectedCities,
        stateIds: this.selectedStates
      });
      this.selectedDealers = dealers;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async handleStateChange(value) {
    try {
      const dealers = await getDealerIds({
        branchIds: this.selectedBranches,
        agentIds: this.selectedAgents,
        cityIds: this.selectedCities,
        stateIds: this.selectedStates
      });
      this.selectedDealers = dealers;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async handleCityChange(value) {
    try {
      const dealers = await getDealerIds({
        branchIds: this.selectedBranches,
        agentIds: this.selectedAgents,
        cityIds: this.selectedCities,
        stateIds: this.selectedStates
      });
      this.selectedDealers = dealers;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  filterMethod(query, item) {
    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title} - ${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  desktopImageUploaded(file) {
    this.formData.desktopImage = file.response;
  }
  mobileImageUploaded(file) {
    this.formData.mobileImage = file.response;
  }
  resetForm() {
    this.mobileImage = [];
    this.desktopImage = [];
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
  }
  async getProducts(query = '') {
    try {
      if (query.length > 2) {
        this.productList = await getProducts(getQuery({
          limit: 10,
          enabled: true,
          name: query,
          filter: {
            enabled: 'eq',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getProductById(productId = 0) {
    try {
      this.productList = await getProducts(getQuery({
        limit: 10,
        enabled: true,
        id: productId,
        filter: {
          enabled: '$eq',
          id: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getCategories() {
    try {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        filter: {
          enabled: '$eq',
          parentId: '$isnull'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getCategoryById(categoryId = 0) {
    try {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        id: categoryId,
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          id: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async saveForm() {
    try {
      // map dealerIds
      const dealerIds = this.selectedDealers.map(dealer => {
        return dealer.id;
      });
      this.formData.dealers = dealerIds;
      this.loading = true;
      this.formData.validFrom = this.$moment(this.validity[0]).format('YYYY-MM-DD');
      this.formData.validTill = this.$moment(this.validity[1]).format('YYYY-MM-DD');
      if (this.isEdit) {
        this.formData.category = {
          id: this.formData.categoryId
        };
        this.formData.product = {
          id: this.formData.productId
        };
        await updateBanner(this.formData.id, this.formData);
      } else {
        delete this.formData.category;
        delete this.formData.product;
        await createBanner(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Banner saved',
        type: 'success',
        duration: 2000
      });
      router.push('/banner/list');
    } catch (error) {
      this.loading = false;
    }
  }
  isDateAllowed(time) {
    return time.getTime() < Date.now() - 8.64e7;
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'BannerDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;